<template>
  <section class="residency__preceptors">
    <v-container>
      <v-heading level="h3">Preceptores</v-heading>
      <v-heading level="h6">Clique em um dos preceptores para ver seu currículo</v-heading>
      <div class="grid">
        <v-card v-for="(preceptor, index) in preceptors" :key="index"
          class="preceptor"
          tag="span"
          :level="2"
          @click="showPreceptor(index)">
            <v-heading level="h6">{{preceptor.name}}</v-heading>
            <div class="crm"><b>CRM:</b> {{preceptor.crm}}</div>
        </v-card>
      </div>
      <v-lightbox :active="!!currPreceptor.crm" @close="currPreceptor = {}">
        <v-heading level="h4">{{currPreceptor.name}}</v-heading>
        <div class="crm"><b>CRM:</b> {{currPreceptor.crm}}</div>
         <v-heading level="h6">Curriculo:</v-heading>
        <body-text>
          <p>{{currPreceptor.curriculo}}</p>
        </body-text>
        <v-heading level="h6">Titulação:</v-heading>
        <body-text>
          <ul>
            <li v-for="(title, titleIndex) in currPreceptor.titles" :key="titleIndex">
              {{title}}
            </li>
          </ul>
        </body-text>
        <v-btn tag="a"
          model="color-a"
          :href="currPreceptor.pdf"
          v-if="currPreceptor.pdf">
            Ver currículo completo
        </v-btn>
      </v-lightbox>
    </v-container>
  </section>
</template>

<script>
import Container from '@/components/layout/Container.vue';
import Card from '@/components/layout/Card.vue';
import Lightbox from '@/components/layout/Lightbox.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import Btn from '@/components/uikit/Btn.vue';
import BodyText from '@/components/uikit/text/BodyText.vue';

export default {
  name: 'ResidencyPreceptors',
  components: {
    'v-container': Container,
    'v-heading': Heading,
    'v-card': Card,
    'v-lightbox': Lightbox,
    'v-btn': Btn,
    'body-text': BodyText,
  },
  props: {
    preceptors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currPreceptor: () => {},
    };
  },
  methods: {
    showPreceptor(preceptor) {
      this.currPreceptor = this.preceptors[preceptor];
    },
  },
};
</script>

<style lang="scss" scoped>
$component: '.residency__preceptors';
#{$component} {
  padding: $section-gutter 0;
  .container {
    > .heading  {
      text-align: center;
    }
    > h3.heading {
      color: $color-d;
    }
    > h6.heading {
      @media screen and (max-width: #{$brakepoint-medium}) {
        margin-bottom: $gutter-xxl;
      }
    }
    .grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: auto;
      grid-gap: $gutter-l;
      max-width: 624px;
      margin: auto;
      text-align: center;
      @media screen and (max-width: #{$brakepoint-medium}) {
        display: block;
      }
    }
    .preceptor {
      padding: $gutter-l;
      cursor: pointer;
      text-align: left;
      transition: transform $transition-duration $transition-timing-function,
        box-shadow $transition-duration $transition-timing-function;
      @media screen and (max-width: #{$brakepoint-medium}) {
        margin-bottom: $gutter-l;
      }
      h6.heading {
        margin-bottom: $gutter-l;
      }
      &:hover {
        transform: translateY(#{-$gutter});
        box-shadow: $box-shadow-xxl;
      }
      &:active {
        transform: translateY(#{-($gutter/2)});
        box-shadow: $box-shadow-xl;
      }
    }
    .crm {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin: 0 $gutter 0 0;
      color: $color-sys-e;
    }
    .lightbox {
      text-align: left;
      h4.heading {
        margin-bottom: $gutter-l;
        text-align: center;
      }
      h6.heading {
        margin: $gutter-l 0;
      }
      .crm {
        justify-content: center;
        margin-bottom: $gutter-xxl;
        b {
          display: inline-block;
          margin-right: $gutter;
        }
      }
      ul li {
        font-size: $font-size-l;
      }
    }
  }
}
</style>
